import type { ScorebugThemeConfig } from '@/lib/live/state'

interface Props {
  homeScore: number
  awayScore: number
  serviceTeam: 'home' | 'away' | null
  isMatchPoint?: { home: boolean; away: boolean }
  isSetPoint?: { home: boolean; away: boolean }
  displayMode?: 'score' | 'sets'
  className?: string
  theme?: ScorebugThemeConfig
}

export default function ScoreBlock({
  homeScore, awayScore, serviceTeam,
  isMatchPoint, isSetPoint, displayMode = 'score', className = '', theme,
}: Props) {
  const isFinalSets = displayMode === 'sets'
  // Colore del punteggio proprio della squadra che batte: se non impostato vale quello generale.
  const battutaCasa = theme?.homeServiceColor ?? theme?.serviceColor ?? 'var(--sb-service-color, #FE7200)'
  const battutaOspite = theme?.awayServiceColor ?? theme?.serviceColor ?? 'var(--sb-service-color, #FE7200)'

  return (
    <div data-section="score" className={`flex items-center justify-center gap-3 ${className}`}>
      {/* Score casa */}
      <div className="relative flex flex-col items-center">
        {!isFinalSets && (isMatchPoint?.home || isSetPoint?.home) && (
          <span
            className={`absolute -top-6 font-bold uppercase px-1.5 py-0.5 rounded ${
              isMatchPoint?.home ? '' : 'bg-yellow-400/20 text-yellow-300'
            }`}
            style={{ fontSize: 18, ...(isMatchPoint?.home ? { background: 'var(--sb-accent-strong, #FE7200)', color: 'var(--sb-secondary-text, #ffffff)' } : {}) }}>
            {isMatchPoint?.home ? 'MP' : 'SP'}
          </span>
        )}
        {isFinalSets && (
          <span className="absolute -top-5 font-bold uppercase tracking-[0.2em]" style={{ fontSize: 18, color: 'var(--sb-text-soft, rgba(255,255,255,0.72))' }}>
            Set
          </span>
        )}
        <span
          className="font-display font-bold tabular-nums leading-none transition-all duration-150"
          style={{ color: isFinalSets || serviceTeam !== 'home' ? 'var(--sb-text, #ffffff)' : battutaCasa }}
        >
          {homeScore}
        </span>
      </div>

      {/* Separatore */}
      <span className="font-display font-bold" style={{ color: theme?.accentStrong ?? 'var(--sb-text-muted, rgba(255,255,255,0.4))' }}>–</span>

      {/* Score ospite */}
      <div className="relative flex flex-col items-center">
        {!isFinalSets && (isMatchPoint?.away || isSetPoint?.away) && (
          <span
            className={`absolute -top-6 font-bold uppercase px-1.5 py-0.5 rounded ${
              isMatchPoint?.away ? '' : 'bg-yellow-400/20 text-yellow-300'
            }`}
            style={{ fontSize: 18, ...(isMatchPoint?.away ? { background: 'var(--sb-accent-strong, #FE7200)', color: 'var(--sb-secondary-text, #ffffff)' } : {}) }}>
            {isMatchPoint?.away ? 'MP' : 'SP'}
          </span>
        )}
        {isFinalSets && (
          <span className="absolute -top-5 font-bold uppercase tracking-[0.2em]" style={{ fontSize: 18 }}>
            Set
          </span>
        )}
        <span
          className="font-display font-bold tabular-nums leading-none transition-all duration-150"
          style={{ color: isFinalSets || serviceTeam !== 'away' ? 'var(--sb-text, #ffffff)' : battutaOspite }}
        >
          {awayScore}
        </span>
      </div>
    </div>
  )
}
